import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';

const OrderHeaderItem = ({
  label,
  value,
  containerClass,
  headerClass,
  contentClass,
  children,
}) => (
  <div className={`order-item-wrapper ${containerClass}`}>
    <span className={`label-item ${headerClass}`}>{label}</span>
    <span className={`value-item ${contentClass}`}>{children || value}</span>
  </div>
);

OrderHeaderItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  containerClass: PropTypes.string,
  headerClass: PropTypes.string,
  contentClass: PropTypes.string,
};

OrderHeaderItem.defaultProps = {
  children: null,
  value: null,
  containerClass: '',
  headerClass: '',
  contentClass: '',
};

export default translate(OrderHeaderItem);
